export default {"src":"/_next/static/media/news-line-mob.0ec8ea5c.svg","height":37,"width":2,"blurWidth":0,"blurHeight":0};